import { render, staticRenderFns } from "./roadStud.vue?vue&type=template&id=7fb896ae"
import script from "./roadStud.vue?vue&type=script&lang=js"
export * from "./roadStud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports